import { callGetConnectedWalletsByUser } from '@app/store/zustand';

import { useWalletStore } from './useWalletStore';

export async function initializeWalletsAsync() {
    return (
        callGetConnectedWalletsByUser({
            variables: {},
            settings: {},
        })
            .then((res) => {
                const wallets = res?.accounts;

                // TODO: Avoid `.setState()` calls. Prefer explicit hook API instead.
                // We could call `clearWallets()` followed by `addWallets(wallets)`.
                useWalletStore.setState({ connectedWallets: wallets ?? [] }); // so the state isn't set to undefined if call fails
            })
            // eslint-disable-next-line no-console
            .catch((error) => console.error(error))
    );
}
